export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "exportMilestoneIsJobTrackingCompleted",
            label: "Job Tracking Completed",
            component: "checkboxbox",
            width: "50%",
          },
          {
            name: "exportMilestoneEntryDate",
            component: "dateselector",
            width: "30%",
            gap: false,

          },
          {
            name: "exportMilestoneCustomerRemark",
            placeholder: "CustomerRemark",
            component: "text-field",
            gap: false,
            width: "30%",
          },
        ],
        row2: [

        ],
      },
    },
  ],
};
